import "../../../assets/scss/components/sections/home/hero.scss";
import { Container, Image } from "react-bootstrap";

import img1 from "../../../assets/images/home/profile-1.png";
import img2 from "../../../assets/images/home/profile-2.png";
import img3 from "../../../assets/images/home/profile-3.png";
import img4 from "../../../assets/images/home/profile-4.png";
import p1 from "../../../assets/images/home/partner-1.svg";
import p2 from "../../../assets/images/home/partner-2.svg";
import p3 from "../../../assets/images/home/partner-3.svg";
import p4 from "../../../assets/images/home/partner-4.svg";
import p5 from "../../../assets/images/home/partner-5.svg";
import p6 from "../../../assets/images/home/partner-6.svg";
import p7 from "../../../assets/images/home/partner-7.svg";
import download_btn from "../../../assets/images/home/download-white-icon.svg";
import check from "../../../assets/images/home/check.svg";
import star from "../../../assets/images/star.svg";
import Heading from "../../templates/heading";
import { useRef, useState } from "react";
import UploadResumeModal from "../../templates/uploadResumeModal";
import SignupModal from "../../templates/signupModal";
import Marquee from "react-fast-marquee";

import { Player } from "@lottiefiles/react-lottie-player";
import animationData from "../../../assets/animations/Lottie R2.json";

const Hero = () => {
  const partnerLogos = [p1, p2, p3, p4, p5, p6, p7];
  const [openCustomModal, setCustomModal] = useState(false);
  const jobURL = useRef(null);

  const handleModal = () => {
    setCustomModal(!openCustomModal);
  };

  const clickCreateResume = () => {

    window.location.href = `${process.env.REACT_APP_APP_URL}/signup?jobURL=${jobURL.current.value}`;
  }

  return (
    <div className="hero-section">
      <Container>
        <div className="hero">
          <div className="images-div">
            <div className="images">
              <Image src={img1} className="img-1" width={50} />
              <Image src={img2} className="img-2" width={50} />
              <Image src={img3} className="img-3" width={50} />
              <Image src={img4} className="img-4" width={50} />
            </div>
            <div>
              <div className="ratings mb-2">
                <Image src={star} className="me-1" />
                <Image src={star} className="me-1" />
                <Image src={star} className="me-1" />
                <Image src={star} className="me-1" />
                <Image src={star} className="me-1" />
              </div>
              <h6 className="images-div-text mb-0 paragraph-small-regular">
                Loved by 10,000+ job seekers
              </h6>
            </div>
          </div>
          <div className="content">
            <Heading
              heading="<span>Get 10X More Job</span> Interviews with AI Resume Builder"
              text="Effortlessly tailor your resume for any job and increase your chances of landing interviews"
            />
            <div className="benefit">
              <div className="benefit-item">
                <div className="check">
                  <Image src={check} />
                </div>
                <p>Automate your job search</p>
              </div>
              <div className="benefit-item">
                <div className="check">
                  <Image src={check} />
                </div>
                <p>Land your next job faster</p>
              </div>
            </div>
            <div className="input-container">
              <input
                type="text"
                placeholder="🔗 Input Job URL"

                ref={jobURL}
              />
              <button className="input-button" onClick={clickCreateResume}>
                <Image src={download_btn} className="me-2" />
                Create Resume
              </button>
            </div>
            <div className="partners">
              <h6 className="heading-6">Works with all leading job platforms</h6>
              <div className="partner-logos d-none d-lg-flex">
                {partnerLogos.map((logo) => (
                  <Image src={logo} className="me-2" />
                ))}
              </div>
              <div className="partner-logos d-lg-none d-block">
                <Marquee speed={50} gradient={false}>
                  {partnerLogos.map((logo, index) => (
                    <img
                      key={`logo-${index}`}
                      src={logo}
                      alt={`Logo ${index + 1}`}
                      className="marquee-logo me-2"
                    />
                  ))}
                </Marquee>
              </div>
            </div>
            {/*<div className="animation">*/}
            {/*  <Player autoplay loop src={animationData} />*/}
            {/*</div>*/}
          </div>
        </div>
        <SignupModal showmodal={openCustomModal} closemodal={handleModal} />
      </Container>
    </div>
  );
};

export default Hero;
